<template>
  <div class="results-wrapper min-h-[100vh]">
    <ResultsComponent />
  </div>
</template>

<script>
import ResultsComponent from '@/components/common/ResultsComponent.vue';

export default {
  name: 'ResultsWrapper',
  components: {
    ResultsComponent,
  },
};
</script>

<style scoped>
.results-wrapper {
  max-width: 90vw;
  margin: auto;
  min-height: calc(100vh - 270px);
}
</style>